import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DocumentsList,
  LogoLoader,
  Modal,
  NewTable,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import H1BView from "./H1B/H1BView";
import { usePagination } from "../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { getAllImmigrations } from "../../../../redux/slices/immigration/immigrationSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { BasisOfH1B, H1BStatus } from "../../../../assets/data/enumData";

const H1B = ({ onEdit }) => {
  const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const { value } = useSelector((state) => state.totalCount);
  const { loading, allImmigrations } = useSelector(
    (state) => state.immigration,
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const isLoading = loading;

  const totalCount = value?.h1b?.data || 0;
  const h1bTableData = allImmigrations?.h1b || [];
  console.log("h1bTableData", h1bTableData);
  const tableData = [
    {
      employeeName: "Revanth Potluri",
      businessUnit: "Tektree",
      recordStatus: "Active",
      h1bType: "New Employment",
      lcaNumber: "I-200-24142-019530",
      filedDate: "2021-06-14T00:00:00.000Z",
      receiptNumber: "IOE0926299232",
      status: "Approved",
      approvedUntil: "2021-09-30T00:00:00.000Z",
      created: "2021-04-16T00:00:00.000Z",
      comments: "--",
      documents: "2",
    },
    {
      employeeName: "Sneha Kotagiri",
      businessUnit: "Tektree",
      recordStatus: "Active",
      h1bType: "Change in Employer",
      lcaNumber: "I-200-24142-019530",
      filedDate: "2021-11-26T00:00:00.000Z",
      receiptNumber: "IOE0926299232",
      status: "Approved",
      approvedUntil: "2027-11-18T00:00:00.000Z",
      created: "2024-12-30T00:00:00.000Z",
      comments: "--",
      documents: "0",
    },
    {
      employeeName: "Omprakash Namani",
      businessUnit: "Tektree",
      recordStatus: "Active",
      h1bType: "Extension",
      lcaNumber: "I-200-24142-019530",
      filedDate: "2024-03-06T00:00:00.000Z",
      receiptNumber: "IOE0926299232",
      status: "Approved",
      approvedUntil: "2027-02-11T00:00:00.000Z",
      created: "2024-08-29T00:00:00.000Z",
      comments: "--",
      documents: "0",
    },
  ];
  const handelDocumetsModal = (documents) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(documents);
  };
  const columns = [
    {
      key: "employeeId",
      label: "Employee Name",
      render: (row) => (
        <SmartTooltip
          description={row.employeeId?.firstName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <span
            className="text-info cursor-pointer line-clamp-1!"
            onClick={() => setSelectedEmployee(row)}
          >
            {row.employeeId?.firstName}
          </span>
        </SmartTooltip>
      ),
    },

    {
      key: "businessUnit",
      label: "Business Unit",
    },
    {
      key: "recordStatus",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={
            row.recordStatus === 1
              ? "Active"
              : row.recordStatus === 2
                ? "Inactive"
                : "Extension"
          }
        />
      ),
      sortable: false,
    },
    {
      key: "processType",
      label: "H-1B Type",
      render: (row) => {
        return (
          <StatusTags
            tag={
              row?.processType === 1
                ? "Premium"
                : row?.processType === 2
                  ? "Normal"
                  : "" || "-"
            }
          /> // Fallback to "Unknown" if label is undefined
        );
      },
    },
    {
      key: "status",
      label: "H-1B Status",
      sortable: false,
      render: (row) => {
        const findType = H1BStatus.find(
          (data) => data.value === row?.status,
        )?.label;
        return (
          <StatusTags tag={findType || "-"} /> // Fallback to "Unknown" if label is undefined
        );
      },
    },
    {
      key: "lcas",
      label: "LCA Number",
    },
    {
      key: "filedOn",
      label: "Filed Date",
      render: (row) => dateFormator(row.filedOn, "month-day-year"),
    },
    {
      key: "receiptNum",
      label: "Receipt Number",
    },
    {
      key: "status_text",
      label: "Status",
      // render: (row) => {
      //   const findType = H1BStatus.find((data) => data.value === row?.status)?.label;
      //   return findType || "-";
      // },
    },
    {
      key: "approvedUntil",
      label: "Approved Until",
      render: (row) => dateFormator(row.approvedUntil, "month-day-year"),
    },
    {
      key: "addedOn",
      label: "Created",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "comments",
      label: "Comments",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.comments}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <div className="line-clamp-1!">{row.comments}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "documents",
      label: "Documents",
      width: "text-nowrap!",
      render: (row) => {
        const documents = (row?.documents || []).map((data) => ({
          filePath: data,
          name: "H1B",
        }));
        return (
          <div
            className="text-info cursor-pointer"
            onClick={
              documents.length > 0
                ? () => handelDocumetsModal(documents)
                : () => {}
            }
          >
            Show Document ({documents?.length || 0})
          </div>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
            onClick={() => onEdit?.(row)}
          />
          <Button
            type="icon"
            icon="history"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(h1bTableData, columns);

  console.log("selectedRows", selectedRows);
  console.log("selectedEmployee", selectedEmployee);
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "h1bs",
        coll: "H1B",
        tname: "h1b",
      }),
    );
    dispatch(
      getAllImmigrations({
        coll: "H1B",
        rsn: "h1b",
        limit,
        page,
        ref: "Employee",
        incl: ["uiid firstName"],
      }),
    );
  }, [dispatch, page, limit]);
  return (
    <div className="flex flex-col overflow-hidden">
      {selectedEmployee ? (
        <H1BView
          employee={selectedEmployee}
          onBack={() => setSelectedEmployee(null)}
        />
      ) : (
        <>
          <TableAdv
            tableId={"immigraton_h1b"}
            rows={mappedRows}
            columns={columns}
            serverPagination={true}
            totalCount={totalCount}
            showCheckbox
            // toolbarRight={[{ DropdownMenu: false }]}
            onSelectionChange={setSelectedRows}
            defaultSelectedRows={selectedRows}
            toolbarRight={{
              search: true,
              filter: true,
              add: [
                {
                  component: (
                    <div className="flex gap-1">
                      <Button title={"Search"} size="sm" />
                      {selectedRows.length == 1 && (
                        <Button title="Delete" size="sm" color="danger" />
                      )}
                      <Button
                        color="black"
                        type="icon"
                        variant="text"
                        icon={"screen_share"}
                      />
                    </div>
                  ),
                },
              ],
            }}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
          />
        </>
      )}
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default H1B;
